'use client';

import { useI18n } from 'next-localization';

import { upperFirst } from 'lodash-es';

import { NeuCheckbox } from '@hcahealthcaredpx/neutron-react';

import { useListingContext } from '../../hooks';

export const GendersFilter = (): JSX.Element => {
  const { t } = useI18n();
  const GENDERS = [t('OAS.Listing.Filters.Male'), t('OAS.Listing.Filters.Female')];

  const { selectedGenders, toggleSelectedGenders } = useListingContext();

  return (
    <div className="my-3">
      {GENDERS.map((gender) => (
        <NeuCheckbox
          key={gender}
          label={gender}
          value={gender}
          checked={selectedGenders?.includes(upperFirst(gender.toLocaleLowerCase()))}
          onNeuChange={() => toggleSelectedGenders(gender ?? '')}
        />
      ))}
    </div>
  );
};
